export default __webpack_public_path__ + "static/logo-b531a8326566c323d8f7cf2ada4e1296.svg";